/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React from "react";
import { ShipmentDetailsUI } from "@innofulfill/hubops-shipment-tracking";
import { useLocation } from "react-router-dom";
import "@innofulfill/hubops-shipment-tracking/dist/assets/hubops-shipment-tracking.css";
import urls from "../api/urls";

// Fixed endpoint (your API)
const endpoint = urls.SHIPMENT_TRACKING_ENDPOINT;

// Interface removed to avoid linting issues in current setup
function ShipmentDetails(props) {
    const { awbNumber: propAwbNumber } = props || {};
    const location = useLocation();

    // Get awbNumber from URL query params
    const params = new URLSearchParams(location.search);
    const awbNumber = propAwbNumber || params.get("awb") || params.get("awbNumber") || ""; // optional default

    return <ShipmentDetailsUI endpoint={endpoint} awbNumber={awbNumber} />;
}

export default ShipmentDetails;
